/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UnreadFaxCountResponse } from './UnreadFaxCountResponse';
import {
    UnreadFaxCountResponseFromJSON,
    UnreadFaxCountResponseFromJSONTyped,
    UnreadFaxCountResponseToJSON,
} from './UnreadFaxCountResponse';

/**
 * 
 * @export
 * @interface GetUnreadFaxCount200Response
 */
export interface GetUnreadFaxCount200Response {
    /**
     * 
     * @type {UnreadFaxCountResponse}
     * @memberof GetUnreadFaxCount200Response
     */
    data?: UnreadFaxCountResponse;
}

/**
 * Check if a given object implements the GetUnreadFaxCount200Response interface.
 */
export function instanceOfGetUnreadFaxCount200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetUnreadFaxCount200ResponseFromJSON(json: any): GetUnreadFaxCount200Response {
    return GetUnreadFaxCount200ResponseFromJSONTyped(json, false);
}

export function GetUnreadFaxCount200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUnreadFaxCount200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : UnreadFaxCountResponseFromJSON(json['data']),
    };
}

export function GetUnreadFaxCount200ResponseToJSON(value?: GetUnreadFaxCount200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': UnreadFaxCountResponseToJSON(value.data),
    };
}

